import request from '../utils/request';

/**创建知识集 */
export function createKnowledgeApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/createKnowledge',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  }, true)
}

/**删除知识集 */
export function delKnowledgeApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/delKnowledge',
    method: 'delete',
    params,
    headers: {
      "authorization": authorization
    }
  }, true)
}

/**知识集详情 */
export function knowledgeDetailApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/knowledge',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  }, true)
}

/**获取企业授权给应用的知识集列表 */
export function knowledgeListApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/list',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  }, true)
}
/**修改知识集 */
export function updateKnowledgeDocApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/updateKnowledgeDoc',
    method: 'put',
    data: params,
    headers: {
      "authorization": authorization
    }
  }, true)
}

/**上传临时文件到专区 */
export function uploadToZoneApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/uploadToZone',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  }, true)
}

/**知识集创建人列表 */
export function createNameListApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/createNameList',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  }, true)
}

/**启用状态 */
export function KnowledStatusApi(params, authorization) {
  return request({
    url: '/api/knowledge/doc/status',
    method: 'put',
    data:params,
    headers: {
      "authorization": authorization
    }
  }, true)
}
